import React, { useState } from "react";
import { Checkbox, Typography, Box, IconButton, Divider } from "@mui/material";
import { ExpandMore, ChevronRight } from "@mui/icons-material";



function getAllChildIds(node) {
  let ids = [];
  if (node.children) {
    for (let child of node.children) {
      ids.push(child.id, ...getAllChildIds(child));
    }
  }
  return ids;
}

function getAllParentIds(tree, childId, parents = []) {
  for (let node of tree) {
    if (node.children) {
      if (node.children.find(child => child.id === childId)) {
        parents.push(node.id);
        getAllParentIds(tree, node.id, parents);
      } else {
        getAllParentIds(node.children, childId, parents);
      }
    }
  }
  return parents;
}

const flatList = (list) => {
    return list.flatMap(item => {
      let children = item.children ? flatList(item.children) : [];
      return [item, ...children];
    })
  }

function MyCheckTreeItem({ node, checked, onCheck, expanded, onExpand, level = 0 }) {
  
  const hasChildren = Boolean(node.children?.length);
  const isExpanded = expanded.includes(node.id);

  const childrenList = flatList(node.children || []).map(child => child.id);

  let hasIndeterminateState = false;
  if (hasChildren) {
    const checkedChildren = childrenList.filter(id => checked.value.includes(id));
    hasIndeterminateState = checkedChildren.length > 0 && checkedChildren.length < childrenList.length;
  }


  return (
    <Box sx={{display:'flex',  marginLeft:'20px', justifyContent:'start', flexDirection:'column'}}>
      <Box sx={{display:'flex', alignContent:'center', alignItems:'center'}}>
        <Divider orientation="vertical" flexItem />
        {hasChildren && (
          <IconButton
            size="small"
            onClick={() => onExpand(node.id)}
          >
            {isExpanded ? <ExpandMore /> : <ChevronRight />}
          </IconButton>
        )}
        {!hasChildren && <Box width={32} />} {/* Para alinhar com itens com ícone */}
        <Checkbox
          checked={checked.value.includes(node.id)}
          indeterminate={hasIndeterminateState}
          color="primary"
          onChange={() => onCheck(node)}
        />
        <Typography >{node.label}</Typography>
      </Box>
      <Divider />
      <Box >
        {hasChildren && isExpanded && (
          <Box>
            {node.children.map(child =>
              <MyCheckTreeItem
                key={child.id}
                node={child}
                checked={checked}
                onCheck={onCheck}
                expanded={expanded}
                onExpand={onExpand}
                level={level + 1}
              />
            )}
          </Box>
        )}
      </Box>
      
    </Box>
  );
}

const MyCheckTree = ({treeData, checked, hasExpanded}) => {
  
  let expandedInitial = [];

  

  if (hasExpanded) {
    expandedInitial = flatList(treeData);
  }

  const [expanded, setExpanded] = useState(expandedInitial.map(item => item.id)); 

  const removeParent = (list, item) => {

    let allParentIds = getAllParentIds(treeData, item.id);
    let parent = expandedInitial[expandedInitial.findIndex(item => item.id === allParentIds[0])]
    
    let todosOsFIlhosMarcados = parent?.children.every(child => list.includes(child.id))
    let algumFilhoMarcado = parent?.children.some(child => list.includes(child.id))
    if (parent?.children && !todosOsFIlhosMarcados && !algumFilhoMarcado) {
      list = list.filter(id => id !== parent.id)
      let allParentParentIds = getAllParentIds(treeData, parent.id);
      if (allParentParentIds.length > 0) {
        return removeParent(list, parent)
      }
      
    }
    return list
  }

  const marcaParent = (list, item) => {

    let allParentIds = getAllParentIds(treeData, item.id);
    let parent = expandedInitial[expandedInitial.findIndex(item => item.id === allParentIds[0])]
    list = [...list, parent.id]
    let allParentParentIds = getAllParentIds(treeData, parent.id);
    if (allParentParentIds.length > 0) {
      return marcaParent(list, parent)
    }
    return list
  }

  // Lógica ao clicar no checkbox
  const handleCheck = (node) => {

    let allChildIds = node.children ? getAllChildIds(node) : [];
    let allParentIds = getAllParentIds(treeData, node.id);

    if (checked.value.includes(node.id)) {
      // Desmarcar nó e seus filhos
      let list = checked.value.filter(id => id !== node.id && !allChildIds.includes(id))
      if (allParentIds?.length > 0) {
        list = removeParent(list, node)
      }
      
      checked.set([...new Set(list)]);

    } else {
      let list = [...checked.value, node.id, ...allChildIds]
      if (allParentIds?.length > 0) {
        list = marcaParent(list, node)
      }
      
      checked.set([...new Set(list)]);
    }
  };

  
  const handleExpand = (id) => {
    setExpanded(expanded.includes(id)
      ? expanded.filter(x => x !== id)
      : [...expanded, id]
    );
  };


  return (
    <Box>
      {treeData.map(node =>
        <MyCheckTreeItem
          key={node.id}
          node={node}
          checked={checked}
          onCheck={handleCheck}
          expanded={expanded}
          onExpand={handleExpand}
        />
      )}
    </Box>
  );
}

export default MyCheckTree